import { ParameterLevel, Parameters } from '@web/common';

export enum FieldTypes {
  DROPDOWN = 'dropdown',
  TEXT = 'text',
  NUMBER = 'number',
}
export interface parameterField {
  title: Parameters;
  parameter: Parameters;
  type: FieldTypes;
  initialValue?: number | string | ParameterLevel;
}

export interface goal {
  title: string;
  description?: string;
  field: parameterField | undefined;
}

export const parameterFields: parameterField[] = [
  {
    title: Parameters.FAT_PERCENTAGE,
    parameter: Parameters.FAT_PERCENTAGE,
    type: FieldTypes.NUMBER,
    initialValue: 30,
  },
  {
    title: Parameters.CARDIO_FITNESS,
    parameter: Parameters.CARDIO_FITNESS,
    type: FieldTypes.DROPDOWN,
    initialValue: ParameterLevel.HIGH,
  },
  {
    title: Parameters.STRESS_LEVEL,
    parameter: Parameters.STRESS_LEVEL,
    type: FieldTypes.DROPDOWN,
    initialValue: ParameterLevel.LOW,
  },
  {
    title: Parameters.PULSE,
    parameter: Parameters.PULSE,
    type: FieldTypes.DROPDOWN,
    initialValue: ParameterLevel.MID,
  },
  {
    title: Parameters.MUSCLE_PERCENTAGE,
    parameter: Parameters.MUSCLE_PERCENTAGE,
    type: FieldTypes.NUMBER,
    initialValue: 25,
  },
];

export const predefinedGoals: goal[] = [
  {
    title: 'lose_weight',
    field: parameterFields.find(
      (entry) => entry.title === Parameters.FAT_PERCENTAGE,
    ),
  },
  {
    title: 'improve_heart_health',
    field: parameterFields.find(
      (entry) => entry.title === Parameters.CARDIO_FITNESS,
    ),
  },
  {
    title: 'reduce_stress',
    field: parameterFields.find(
      (entry) => entry.title === Parameters.STRESS_LEVEL,
    ),
  },
];
